import type { Location } from './types';

/**
 * Las 5 zonas del hub de barrio de la beta. Nombres y emoji definidos por
 * encargo directo de Adri para el Bloque 1 (no son narrativa de misión, son
 * la rotulación del hub) — el contenido narrativo real (misiones, diálogos)
 * llega en bloques posteriores.
 */
export const locations: Location[] = [
  {
    id: 'la-casa',
    nombre: 'LA CASA',
    emoji: '🏠',
    umbralRespetoDesbloqueo: 0,
    misionesDisponibles: [],
  },
  {
    id: 'interior-casa',
    nombre: 'INTERIOR DE LA CASA',
    emoji: '🛋️',
    umbralRespetoDesbloqueo: 0,
    misionesDisponibles: [],
  },
  {
    id: 'campo-futbol',
    nombre: 'CAMPO DE FÚTBOL CASA',
    emoji: '⚽',
    umbralRespetoDesbloqueo: 0,
    misionesDisponibles: [],
  },
  {
    id: 'el-monte',
    nombre: 'EL MONTE',
    emoji: '🌲',
    umbralRespetoDesbloqueo: 0,
    misionesDisponibles: [],
  },
  {
    id: 'el-barrio',
    nombre: 'EL BARRIO',
    emoji: '🏘️',
    umbralRespetoDesbloqueo: 0,
    misionesDisponibles: [],
  },
];
